import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Attachment } from '../../../_interfaces/Attachment';
import { DarkmodeService } from '../../../_provider/darkmode.service';
import { TicketEmployee } from '../../../_provider/tickets/ticket.service';
import { AuthService, ROLE } from 'src/app/_provider/auth.service';
import { TicketServiceBase } from 'src/app/_provider/tickets/ticketBase.service';
import { TicketCustomer } from 'src/app/_provider/tickets/ticketCustumer.service';
import { WawiConnectorService } from 'src/app/_provider/wawi-connector/wawi-connector.service';
@Component({
  selector: 'app-ticket-detail-assets',
  templateUrl: './ticket-detail-assets.component.html',
  styleUrls: ['./ticket-detail-assets.component.scss'],
})

export class TicketDetailAssetsComponent{

  @ViewChild("content", {static: false}) content: ElementRef
  @Input() canDelete: boolean = true
  public isDarkmode: boolean
  
  private darkmodeSub: Subscription

  public ticketSrv: TicketServiceBase

  constructor(
    private darkmode: DarkmodeService,
    public ticketSrvEmployee: TicketEmployee.TicketService,
    public ticketSrvCustomer: TicketCustomer.TicketService,
    private authSrv: AuthService,
    private wawiConnectorSrv: WawiConnectorService
  ) { 
    this.ticketSrv = this.authSrv.role == ROLE.employee ? this.ticketSrvEmployee : this.ticketSrvCustomer
    this.darkmodeSub = this.darkmode.isDarkMode.subscribe(result=>{
      if(result !== null)this.isDarkmode = result
    }) 
  }

  async ngOnInit(){
    await this.wawiConnectorSrv.initConnector()
  }

  ngOnDestroy(){
    this.darkmodeSub.unsubscribe()
  }

  public addFile(file: Attachment){
    if(file) (this.ticketSrv as TicketEmployee.TicketService).addFile(file)
  }
}
